

import { Injectable } from '@angular/core';
import { StoreService } from './store.service';


@Injectable({ providedIn: 'root' })
export class PriceHintService {
    static DEFAULT_PRICE_HINT: string = "* ALL SHOWN PRICES ARE EXCL. VAT AND EX WORKS"
    static US_PRICE_HINT: string = "Prices in $ USD exclude Domestic Shipping Charges and applicable Sales Tax"

    constructor(private storeService: StoreService) {
    }

    getPriceHint(): string {
        return this.storeService.isStoreUS() ? PriceHintService.US_PRICE_HINT : PriceHintService.DEFAULT_PRICE_HINT
    }
}
